import * as React from 'react';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import IconButton from '@mui/material/IconButton';
import { KpiContext } from '../../../../context/context';
import { useLocation } from "react-router";

export default function KpiSection({ disabled = false }) {

    const location = useLocation();

    const [kpiContext, setKpiContext] = React.useContext(KpiContext);

    const handleClick = () => {
        setKpiContext((kpiContext == 'none') ? 'block' : 'none');
    };

    return (
        <span style={{ cursor: 'pointer' }}>
            <IconButton
                onClick={handleClick}
            >
                <LeaderboardIcon />
            </IconButton>
        </span>
    )
}